export const SELECTED_TAB_CHANGED = 'SELECTED_TAB_CHANGED';

export function changeSelectedTab(panelId, tab) {
    return {
        type: SELECTED_TAB_CHANGED,
        payload: { panelId, tab },
    };
}
